import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcDevelopementColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3.5,
			y: 5.5,
			width: 21,
			height: 17,
			rx: 2,
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 7.5C3.5 6.39543 4.39543 5.5 5.5 5.5H22.5C23.6046 5.5 24.5 6.39543 24.5 7.5V9.1H3.5V7.5Z",
			fill: "#8C81F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.5104 20.0561L15.3458 10.8794L14.1691 10.6441L12.3337 19.8208L13.5104 20.0561ZM11.6485 12.5501L8.84855 15.3501L11.6485 18.1501L10.8 18.9987L7.15149 15.3501L10.8 11.7016L11.6485 12.5501ZM16.3515 12.5501L19.1515 15.3501L16.3515 18.1501L17.2 18.9987L20.8485 15.3501L17.2 11.7016L16.3515 12.5501Z",
			fill: "white"
		})
	]
});
export default SvgIcDevelopementColor;
